import React, { PureComponent, Fragment } from 'react';
import { Link } from 'formlabs-web-components/Link';
import { Picture } from 'formlabs-web-components/Media';
import { Grid, Cell } from 'formlabs-web-components/Grid';

import './HeaderMenu.module.css';
import { withTranslation } from 'react-i18next';
class ImageGridDropdown extends PureComponent {
  state = {
    hoverOptions: this.props.hoverOptions
  };
  handleMenuClose = () => {
    this.props.handleHoverMenuClose();
  };

  render() {
    const { hoverOptions, dropdownOpen, data, t } = this.props;
    const { children } = data[hoverOptions];
    let index = 0;
    return (
      <Fragment>
        {children.length >= 1 && (
          <Fragment>
            <nav
              styleName={`dropdown image-grid-dropdown open-${dropdownOpen}`}
              aria-label={t('Show dropdown menu')}
            >
              <div styleName="top-grey-border">
                <Grid
                  direction="x"
                  hasContainer={true}
                  gutters="padding"
                  primaryAlignment="align-center"
                >
                  {children.map(child => {
                    index += child.visible ? 1 : 0;
                    return child.visible ? (
                      <Cell
                        mediumSize={child.sizing}
                        mediumOffset={0}
                        largeOffset={0}
                        styles={{
                          paddingBottom: '60px',
                          display: 'flex',
                          justifyContent: 'flex-end',
                          flexDirection: 'column'
                        }}
                        key={`${child.image}${child.url}`}
                      >
                        <div
                          styleName={`fade-img`}
                          style={{ animationDelay: `${index * 0.125}s` }}
                        >
                          <Link
                            to={child.url}
                            aria-label={child.name}
                            openInNewWindow={child.newWindow}
                          >
                            <Picture
                              largeImage={child.image}
                              lazyload={false}
                              alt={child.name}
                            />
                          </Link>
                          <Link
                            to={child.url}
                            styleName={`dropdown-left`}
                            openInNewWindow={child.newWindow}
                          >
                            <span>{child.name} </span>
                          </Link>
                        </div>
                      </Cell>
                    ) : null;
                  })}
                </Grid>
              </div>
            </nav>
            <div
              styleName={`overlay open-${dropdownOpen}`}
              onMouseEnter={this.handleMenuClose}
            />
          </Fragment>
        )}
        {children && (
          <Fragment>
            <div styleName={`dropdown open-false`} />
            <div
              styleName={`overlay overlay-clear open-false`}
              onMouseEnter={this.handleMenuClose}
            />
          </Fragment>
        )}
      </Fragment>
    );
  }
}

export default withTranslation()(ImageGridDropdown);
